<template lang="html">
  <div class="main-body" v-loading="listLoading" element-loading-text="Loading..." element-loading-spinner="el-icon-loading">
    <div class="main-body-search">
      <!-- 页面顶部的查询输入框 -->
      <el-row id="searchRow">
        <el-col :span="24" class="toolbars" style="padding-bottom: 0px;">
          <el-form v-model="filter">
            <div class="block">
              <el-input style="width:20%" :clearable="true" v-model="filter.userAccount" placeholder="用户名称" size="small"></el-input>
              <!--
              <el-select v-model="filter.status" size="small">
                <el-option v-for="(item, index) in userStatus" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            -->
              <el-form-item style="float:right">
                <el-button type="primary" class="el-icon-search" style="width:150px;" @click="search" size="small">&nbsp;查询</el-button>
                <el-button type="primary" class="el-icon-plus" @click="addUser" style="width:150px;" size="small">&nbsp;新增账户</el-button>
              </el-form-item>
            </div>
          </el-form>
        </el-col>
      </el-row>
    </div>
    <div class="main-body-table">
      <!-- 用户账户的表格 -->
      <el-row id="listRow">
        <el-col :span="24">
          <el-table :data="userList" border tooltip-effect="light" style="width:100%;" :height="accountHeight">
            <el-table-column align="center" type="index"  fixed label="序号" width="60"></el-table-column>
            <el-table-column align="center" prop="userAccount" label="用户名称"></el-table-column>
            <el-table-column align="center" prop="roleNames" label="关联角色"></el-table-column>
            <el-table-column align="center" prop="status" width="120" label="状态">
              <template slot-scope="scope">
                <span>{{scope.row.status === 'user-status-1' ? '正常' : '注销'}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="220">
              <template slot-scope="scope">
                  <el-button type="primary" round  size="small" style="width:80px;" @click="editor(scope.row, scope.$index)">编辑</el-button>
                  <el-button type="danger" round size="small" style="width:80px;" @click="remove(scope.row, scope.$index)">注销</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="block" style="text-align:center;">
            <el-pagination @current-change="handleCurrentChange" :current-page="page.currentPage" :page-size="page.pageSize" layout="total, prev, pager, next, jumper" :total="page.totalCount">
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-dialog
      v-dialogDrag
      ref="roledialog"
      :title="dlgTitle"
      :visible.sync="showUserForm"
      @close="closeDialog"
      :close-on-click-modal="false"
    >
              <el-form :model="userForm" style="margin-left:60px;" ref="userForm" :rules="ruler" label-position="top">
                    <el-form-item prop="userAccount" label="账户名称">
                      <el-col :span="21">
                        <el-input :maxlength="15" v-model.trim="userForm.userAccount" size="small" placeholder="请输入账户名称"></el-input>
                      </el-col>
                    </el-form-item>
                    <el-form-item prop="accountRoles" label="账户角色">
                      <el-col :span="21">
                        <template>
                          <el-select v-model="userForm.accountRoles" multiple placeholder="请选择角色" :collapse-tags="true" style="width:100%" size="small">
                            <el-option v-for="item in roles" :key="item.id" :label="item.roleName" :value="item.id">
                            </el-option>
                          </el-select>
                        </template>
                      </el-col>
                    </el-form-item>

              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click.native="resetForm('userForm')">关闭</el-button>
                <el-button
                  type="primary"
                  @click="save('userForm')"
                  :loading="formLoading"
                  >保存</el-button>
              </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getUsers,
  saveUser,
  updateUser,
  deleteUser
}
from '../../api/sum/User';
import {
  getRoles
}
from '../../api/sum/Role';
export default {
  data() {
    return {
      page: {
        currentPage: 1,
        pageSize: 15,
        totalCount: 0
      },
      dialogFormVisible: false,
      showUserForm: false, // 进行用户角色分配的form表单隐藏的属性返回值
      canEdit: false,
      edit: true,
      buttonControl: 0,
      filter: {
        userAccount: '',
        status: ''
      },
      userForm: {
        id: '',
        status: 'user-status-1',
        userAccount: '',
        personId: '',
        accountRoles: []
      },
      userList: [],
      listLoading: false,
      roles: [],
      accountHeight: document.documentElement.clientHeight - 245,
      dlgTitle: '',
      formLoading: false
    };
  },
  computed: {
    ruler() {
      return {
        userAccount: [{
          required: true,
          message: '用户名不能为空'
        }],
        accountRoles: [{
          required: true,
          message: '账户角色不能为空！'
        }]
      };
    },
    addOrUpdateHeight() {
      let wh = this.accountHeight + 80;
      return wh;
    },
    userStatus() {
      let arrays = [{label: '正常', value: 'user-status-1'}, {label: '已删除', value: 'user-status-2'}];
      return arrays;
    }
  },
  methods: {
    currentChange(val, selected) { // 点击当前行变色
      if (!val || !val.id) {
        return;
      }
    },
    findRole(userId) {
      this.listLoading = true;
      var params = {};
      if (userId !== undefined && userId !== null && userId !== '') {
        params.userId = userId;
      }
      params.current = 1;
      params.size = 10000;
      getRoles(params).then(rep => {
        this.listLoading = false;
        if (userId && userId !== null && userId !== '') {
          var uroles = rep.data;
          this.userForm.accountRoles = [];
          if (uroles !== null && uroles.length > 0) {
            for (var i = 0; i < uroles.length; i++) {
              this.userForm.accountRoles.push(uroles[i].id);
            }
          }
        } else {
          this.roles = rep.data;
        }
      }).catch(error => {
        this.listLoading = false;
        this.$message({
          message: error.msg,
          type: 'error'
        });
        return error;
      });
    },
    search() { // 搜索
      this.page.currentPage = 1;
      this.page.totalCount = 0;
      this.loadData();
    },
    closeDialog() {
      // this.$refs.tree.resetChecked()
      this.roleForm = {}
      this.roleFormVisible = false
      this.treeData = []
    },
    loadData() { // 加载列表数据
      this.listLoading = true;
      this.showUserForm = false;
      let params = {
        current: this.page.currentPage,
        size: this.page.pageSize,
        userAccount: this.filter.userAccount,
        status: this.filter.status
      };
      if (this.filter.status === undefined || this.filter.status === '' || this.filter.status === 'user-status-1') {
        this.buttonControl = 0;
      } else {
        this.buttonControl = 1;
      }
      getUsers(params).then(rep => {
        this.listLoading = false;
        // alert(JSON.stringify(rep.data));
        this.userList = rep.data;
        this.page.totalCount = rep.total;
      }).catch(error => {
        this.listLoading = false;
        this.$message({
          message: error.msg,
          type: 'error'
        });
        return error;
      });
    },
    addUser() { //  新增用户
      this.edit = true;
      this.canEdit = false;
      this.userForm.id = '';
      this.userForm.status = 'user-status-1';
      this.userForm.userAccount = '';
      this.userForm.accountRoles = [];
      this.dlgTitle = '新增用户';
      this.showUserForm = true;
    },
    editor(row, index) { // 编辑数据
      if (!row.id) {
        return;
      }
      this.listLoading = false;
      this.edit = false;
      this.showUserForm = true;
      this.userForm.id = row.id;
      this.userForm.userAccount = row.userAccount;
      this.dlgTitle = '编辑用户';
      if (row.roleIdList !== null && row.roleIdList !== undefined && row.roleIdList !== '') {
        this.userForm.accountRoles = row.roleIdList;
      }
      this.canEdit = true;
    },
    resetForm(formName) { // 表单中 取消 按钮数据重置事件
      this.$refs[formName].resetFields();
      this.showUserForm = false; // 关闭表单编辑
    },
    save() { // 保存
      this.$refs.userForm.validate((valid) => {
        if (valid) {
          let params = this.userForm;
          if (this.userForm.id === null || this.userForm.id === undefined || this.userForm.id.length === 0) {
            this.listLoading = true;
            params.roleIdList = params.accountRoles;
            saveUser(params).then(rep => {
              this.$refs.userForm.resetFields();
              this.$message({
                message: '保存成功',
                type: 'success',
                duration: 1000
              });
              this.showUserForm = false;
              this.loadData();
            }).catch(error => {
              this.listLoading = false;
              this.$message({
                message: error.msg,
                type: 'error',
                duration: 1000
              });
            });
          } else {
            this.update();
          }
        }
      });
    },
    update() { // 编辑时更新
      this.$refs.userForm.validate((valid) => {
        if (valid) {
          this.listLoading = true;
          let params = this.userForm;
          this.listLoading = true;
          params.roleIdList = params.accountRoles;
          updateUser(params).then(rep => {
            this.$refs.userForm.resetFields();
            this.$message({
              message: '保存成功',
              type: 'success',
              duration: 1000
            });
            this.showUserForm = false;
            this.loadData();
          }).catch(error => {
            this.listLoading = false;
            this.$message({
              message: error.msg,
              type: 'error',
              duration: 1000
            });
          });
        }
      });
    },
    remove(row, index) { // 注销用户
      this.showUserForm = false;
      this.$confirm('您确认要注销这个账户吗？此操作不可恢复！', '提示 !', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonClass: 'confirm',
        cancelButtonClass: 'cancel',
        type: 'warning'
      }).then(() => {
        this.listLoading = true;
        deleteUser({
          id: row.id
        }).then(rep => {
          this.$message({
            message: '账户注销成功',
            type: 'success',
            duration: 1000
          });
          this.loadData();
        }).catch(error => {
          this.listLoading = false;
          this.$message({
            message: error.msg,
            type: 'error',
            duration: 1000
          });
          return error;
        });
      });
    },
    handleCurrentChange(val) {
      //console.log(val);
      this.page.currentPage = val;
    //  console.log(this.page.currentPage);
      this.loadData();
    }
  },
  mounted() {
    this.loadData();
    this.findRole();
  },
  created() {
    const that = this;
    window.onresize = () => {
      that.accountHeight = document.documentElement.clientHeight - 245;
    };
  }
};
</script>
<style lang="css">
</style>
